import React, { useContext } from "react";
import { Tag, Button } from "antd";
import { FormOutlined, CloseOutlined, CheckCircleOutlined, LinkOutlined } from "@ant-design/icons";
import { EstadoVistaColaborador } from "enum/EstadoVistaColaborador";
import { useAtom } from "jotai";
import {
	erroresFormularioAtom,
	formularioSeleccionadoAtom,
	visibleVisorFormularioAtom,
	visibleModalConsentimientoDatosAtom,
	documentoConsentimientoAtom,
} from "pages/v3/mis-pendientes/componentes/MisDocumentosWeb/MisDocumentosWebStorage";
import { useFormContext } from "react-hook-form";
import { MisDocumentosContext } from "context/v3/MisDocumentosContext";

const Header = ({ loadingPdf }) => {
	const { mostrarModalFirmarFormulario } = useContext(MisDocumentosContext);

	const [formularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [, setVisibleVisorFormulario] = useAtom(visibleVisorFormularioAtom);
	const [, setErroresFormulario] = useAtom(erroresFormularioAtom);
	const [documentoConsentimiento] = useAtom(documentoConsentimientoAtom);
	const [, setVisibleModalConsentimiento] = useAtom(visibleModalConsentimientoDatosAtom);

	const { handleSubmit } = useFormContext();

	// ── Cerrar visor ────────────────────────────────────────────────────────
	// Si el documento que se estaba viendo es el de consentimiento pendiente y se
	// cierra sin firmar, se vuelve a mostrar el modal para que no quede sin resolver.

	const onClickBtnCerrar = () => {
		setVisibleVisorFormulario(false);
		if (documentoConsentimiento && formularioSeleccionado?.id === documentoConsentimiento.id) {
			setVisibleModalConsentimiento(true);
		}
	};

	// ── Flujo normal de firma ────────────────────────────────────────────────

	const onSubmit = (datosFormulario) => {
		mostrarModalFirmarFormulario(datosFormulario);
	};

	const onError = (errores) => {
		setErroresFormulario({ ...errores });
	};

	const onClickBtnFirmar = () => {
		handleSubmit(onSubmit, onError)();
	};

	// ── Render ───────────────────────────────────────────────────────────────

	return (
		<div className="visor-pdf-header" style={{ borderBottom: "0px" }}>
			<div className="informacion">
				<FormOutlined className="icono" />
				<div className="texto">
					<span>
						<span className="periodo">{formularioSeleccionado?.periodo}</span>
						{" - "}
						<span className="documento">{formularioSeleccionado?.nombreDocumento}</span>
					</span>
					<span className="estado">
						<EstadoDocumento estado={formularioSeleccionado?.estadoVistaColaborador} />
					</span>
				</div>
			</div>

			<div className="acciones">
				{formularioSeleccionado?.mostrarlink && formularioSeleccionado?.link && (
					<Button
						icon={<LinkOutlined />}
						onClick={() => window.open(formularioSeleccionado.link, '_blank', 'noopener,noreferrer')}
						style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#fff', marginRight: 12 }}
					>
						Ver Tutorial
					</Button>
				)}
				<Button
					type="primary"
					onClick={onClickBtnFirmar}
					loading={loadingPdf}
					disabled={loadingPdf}
				>
					{formularioSeleccionado.requiereFirmaColaborador
						? "Firmar Documento"
						: "Confirmar Visualización"}
				</Button>
				<div className="visor-pdf-header-separador" />
				<Button type="text" className="cerrar" onClick={onClickBtnCerrar}>
					<CloseOutlined style={{ fontSize: "16px" }} />
				</Button>
			</div>
		</div>
	);
};

const EstadoDocumento = ({ estado }) => {
	if (estado === EstadoVistaColaborador.PENDIENTE) {
		return <Tag color="volcano">{estado}</Tag>;
	}
	return (
		<Tag color="green" icon={<CheckCircleOutlined />}>
			{estado}
		</Tag>
	);
};

export default Header;
